import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { Fragment } from "react";
import { twJoin } from "tailwind-merge";

export interface Crumb {
  to: string;
  label: string;
}

export const Breadcrumbs = ({ crumbs }: { crumbs: Crumb[] }) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <Fragment key={crumb.to}>
            <Link
              className={twJoin(
                "body-sm",
                isLast ? "text-foreground" : "text-muted-foreground"
              )}
              to={crumb.to}
            >
              {crumb.label}
            </Link>
            {!isLast && (
              <ChevronRight className="text-muted-foreground size-4" />
            )}
          </Fragment>
        );
      })}
    </div>
  );
};
